export const GlobalMessages = {
  login: {
    officeName: "TS-Atende",
    textMuted: "Preencha os dados abaixo",
    input: {
      placeholder: "Digite o CPF ou CNPJ",
      error: "Obrigatório preencher CPF ou CNPJ",
    },
    submitButton: "Consultar",
  },

  code2Factor: {
    placeholder: "Digite o código recebido",
    messageOnTyping: "Digite a placa do veículo",
    subTitle:
      "Clique em receber código e após recebê-lo informe para continuar",
    error: "Este campo não pode ficar vazio.",
    errorInvalid: "Digite os 6 caracteres recebidos.",
    submitButton: "Continuar",
    submitSendCode: "Receber código",
    titleToMethodSend: "Enviar código por",
  },
};
